import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { MenuGetAllByGroupService } from '../../services';

export const fetchMenuGetAllByGroup = createAsyncThunk(
    'menuGetAllByGroup/fetchMenuGetAllByGroup',
    async ({ id }) => {
        const response = await MenuGetAllByGroupService(id)
        return response.result;
    }
);

const menuGetAllByGroupSlice = createSlice({
    name: 'menuGetAllByGroup',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMenuGetAllByGroup.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchMenuGetAllByGroup.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchMenuGetAllByGroup.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default menuGetAllByGroupSlice.reducer;
